<template>
    <div>
        <!--搜索  -->
          <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item>优客码</el-breadcrumb-item>
                <el-breadcrumb-item>消息管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-card>

        
        <el-row :gutter="10" class="index-head">
            <el-col :span="4">
                <el-select v-model="statusValue" placeholder="请选择活动">
                    <el-option v-for="item in GLOBALState.erw_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-date-picker v-model="timeinterval" type="daterange" clearable value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-col>
            <el-col :span="12">
                <el-button type="primary" @click="handleButton(1)"> 搜 索 </el-button>
                <el-button type="primary" @click="handleButton(2)"> 重 置 </el-button>
            </el-col>
        </el-row>
        <!-- table -->
        <div class="table-content">
            <el-table :data="list" border v-loading="listLoading">
                <el-table-column label="编号" prop="id"></el-table-column>
                <el-table-column label="活动名称" prop="act_name"></el-table-column>
                <!--  <el-table-column label="事件类型"
                         prop="shop_name"></el-table-column> -->
                <el-table-column label="事件消息" prop="contents"></el-table-column>
                <el-table-column label="触发时间" prop="create_time"></el-table-column>
                <!--   <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type='text'
                       @click="handleButton(3,scope.row.id)">查看</el-button>
          </template>
        </el-table-column> -->
            </el-table>
        </div>
        <!-- 分页 -->
        <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
        <!-- 详情 -->
        <div v-if="goodsVisible">
            <orderDetails :details_id="detail_id" @closeModel="initModel(1)"></orderDetails>
        </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { getshoplist, getmessage } from "@/api/erweima/index";
import pagination from "@/components/pagination/index.vue";
import orderDetails from "@/views/orderManage/mallOrder/common";
export default {
    props: {},
    data() {
        return {
            goodsname: "",
            potValue: "",
            statusValue: "",
            timeinterval: "",
            list: [{ id: 1, name: 555 }],
            pageSize: 5,
            pageNum: 0,
            total: 0,
            listLoading: false,
            goodsVisible: false,
            detais_id: "",
        };
    },
    mounted() {
        this.getmessage_();
    },
    methods: {
        initModel(num) {
            if (num == 1) {
                this.goodsVisible = false;
            }
        },
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.getmessage_();
        },
        handleButton(key, detais_id) {
            switch (key) {
                case 1:
                    this.pageNum = 0;
                    this.getmessage_();
                    break;
                case 2:
                    this.statusValue = "";
                    this.timeinterval = "";
                    this.pageNum = 0;
                    this.getmessage_();
                    break;
                /*   case 2:
            console.log(detais_id, 'detais_id')
            this.goodsVisible = true
            this.detais_id = detais_id
            break; */

                default:
                    break;
            }
        },
        //店铺
        getshoplist_() {
            let par = {
                token: this.$getSessionStorage("token"),
            };
            getshoplist(par)
                .then((res) => {
                    if (res.code == 1) {
                        this.mailOptionsCopy = res.data.list;
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        //列表getmessage
        getmessage_() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                offset: this.pageNum,
                limit: this.pageSize,
            };
            if (this.statusValue !== "") {
                par.rebate_id = this.statusValue;
            }
            if (this.timeinterval !== "") {
                par.begen_time = this.timeinterval[0];
                par.end_time = this.timeinterval[1];
            }
            getmessage(par).then((res) => {
                this.listLoading = false;
                if (res.code == 1) {
                    this.list = res.data.list;
                    this.total = parseInt(res.data.count);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    components: {
        pagination,
        orderDetails,
    },
};
</script>

<style scoped lang="scss">
.index-head {
    width: 100%;
    padding: 16px 0px 16px 0px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.7);
}
 .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 20px;
        color: #000000;
        width: 100%;
        padding: 15px 32px;
    }
.main {
        min-width: 1200px;
        margin: 20px;
           .el-card {
        min-height: 780px;
    }
}
</style>
